import axios from "axios";
import VueAxios from "vue-axios";
import { Message, MessageBox } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { getLocale } from "@/utils/locale";
import qs from "qs";
import Vue from "vue";

// 根据URL获取HOST
const hosts = {
  "base:": process.env.VUE_APP_BASE_API,
  "mall:": process.env.VUE_APP_MALL_API,
};

function switchHost(config) {
  config.baseURL = getBaseURL(config.url);
  config.url = getUrl(config.url);
  function getBaseURL(url) {
    const keys = Object.keys(hosts);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (url.startsWith(key)) {
        return hosts[key];
      }
    }
    console.log(
      "无法根据URL:" + url + ", 匹配到Host, 使用默认Host: " + process.env.VUE_APP_BASE_API
    );
    return process.env.VUE_APP_BASE_API;
  }
  function getUrl(url) {
    const index = url.indexOf(":");
    if (index <= 0) {
      return url;
    }
    return url.substring(index + 1);
  }
}
const formatFormDataKey = "$__formData___";

function isFormData(data) {
  return data && data[formatFormDataKey] === "formData";
}

// create an axios instance
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 20000, // request timeout,
});

// 设置form请求
axiosInstance.form = function (url, data, config) {
  data[formatFormDataKey] = "formData";
  return this.post(url, data, config);
};

// request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // 动态切换host
    switchHost(config);

    if (store.getters.token) {
      // config.headers.Authorization = "Bearer " + getToken();
      config.headers["X-User-Token"] = getToken();
      config.headers["X-User-Locale"] = getLocale();
    }

    // 如果是form请求
    if (isFormData(config.data)) {
      delete config.data[formatFormDataKey];
      config.data = qs.stringify(config.data); // 转为formdata数据格式
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (res.success !== true) {
      Message({
        message: res.message || "Error",
        type: "error",
        duration: 5 * 1000,
      });

      if (res.errorCode === 1) {
        MessageBox.confirm(
          "You have been logged out, you can cancel to stay on this page, or log in again",
          "Confirm logout",
          {
            confirmButtonText: "Re-Login",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        ).then(() => {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        });
      }
      return Promise.reject(res);
    }
    return Promise.resolve(res.data);
  },
  (error) => {
    console.log(`err${error}`); // for debug
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000,
    // });

    const res = error.response ? error.response.data : null;
    if (res && res.success === false) {
      return Promise.reject(res);
    } else {
      return Promise.reject(error);
    }
  }
);

Vue.use(VueAxios, axiosInstance);
